var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    stroke: "#9DA1B5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5389 4C11.5711 3.81612 11.5627 3.62742 11.5143 3.44714C11.4658 3.26686 11.3785 3.09937 11.2584 2.95643C11.1383 2.81349 10.9884 2.69856 10.8192 2.61971C10.65 2.54086 10.4656 2.5 10.2789 2.5H3.72451C3.53783 2.5 3.35342 2.54086 3.18421 2.61971C3.015 2.69856 2.86509 2.81349 2.74502 2.95643C2.62495 3.09937 2.53762 3.26686 2.48916 3.44714C2.4407 3.62742 2.43229 3.81612 2.46451 4M10.3017 2.5C10.3185 2.344 10.3275 2.2666 10.3275 2.2024C10.3282 1.90582 10.219 1.6195 10.021 1.39868C9.82297 1.17786 9.55021 1.03819 9.25531 1.0066C9.19171 1 9.11371 1 8.95771 1H5.04571C4.88971 1 4.81111 1 4.74751 1.0066C4.45261 1.03819 4.17986 1.17786 3.98186 1.39868C3.78387 1.6195 3.67466 1.90582 3.67531 2.2024C3.67531 2.2666 3.68371 2.3446 3.70111 2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8002 10.6H5.2002M12.5166 9.8758C12.3066 11.3638 12.2016 12.1084 11.6634 12.5542C11.1252 13 10.3314 13 8.7432 13H5.2572C3.6696 13 2.8752 13 2.337 12.5542C1.7988 12.1084 1.6938 11.3644 1.4838 9.8758L1.2306 8.0758C0.962398 6.1774 0.828597 5.2288 1.3974 4.6138C1.9662 4 2.979 4 5.0034 4H8.997C11.0214 4 12.0342 4 12.603 4.6144C13.0518 5.0998 13.0632 5.794 12.9156 7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryIcon);
export default __webpack_public_path__ + "static/media/libraryIcon.66d35aaac6c9229fc1d3b023ccdae063.svg";
export { ForwardRef as ReactComponent };